import React from "react";
// nodejs library that concatenates strings
import classnames from "classnames";
// reactstrap components
import {  Button,  Collapse,  NavbarBrand,  Navbar,  NavItem,  NavLink,  Nav,  Container, Modal} from "reactstrap";
import $ from "jquery";
import {str} from "views/examples/StorePage";
import {item} from "views/index-sections/SectionFood";
import {item2} from "views/index-sections/SectionGrocery";
var stuff = str;
//JQUERY
$(document).ready(function(){
  stuff=item+item2; // initializing the checkout string
  $("#cart").click(function() {
    stuff=item+item2; // to update items in the cart
  });
});
function IndexNavbar() {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [navbarCollapse, setNavbarCollapse] = React.useState(false);
  const toggleNavbarCollapse = () => {
    setNavbarCollapse(!navbarCollapse);
    document.documentElement.classList.toggle("nav-open");
  };
  const [modal, setModal] = React.useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };
  const cancel = () =>{
    document.getElementById("list").innerHTML=" <br/><br/>";
  };
  const checkout = () =>{
    setModal(!modal);
    document.getElementById("list").innerHTML="<br/><br/> ";
  };
  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 299 ||
        document.body.scrollTop > 299
      ) {
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < 300 ||
        document.body.scrollTop < 300
      ) {
        setNavbarColor("navbar-transparent");
      }
    };

    window.addEventListener("scroll", updateNavbarColor);

    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });
  return (
    <Navbar className={classnames("fixed-top", navbarColor)} expand="lg">
      <Container>
        <div className="navbar-translate">
          <NavbarBrand
            data-placement="bottom"
            href="/index"
            target=""
            title="Delivering Happiness"
          >
            Super Service
          </NavbarBrand>
          <button
            aria-expanded={navbarCollapse}
            className={classnames("navbar-toggler navbar-toggler", {
              toggled: navbarCollapse
            })}
            onClick={toggleNavbarCollapse}
          >
            <span className="navbar-toggler-bar bar1" />
            <span className="navbar-toggler-bar bar2" />
            <span className="navbar-toggler-bar bar3" />
          </button>
        </div>
        <div name="buy">
        <Modal isOpen={modal} toggle={toggleModal}>
                <div className="modal-header">
                  <button
                    aria-label="Close"
                    className="close"
                    type="button"
                    onClick={toggleModal}
                  >
                    <span aria-hidden={true}>×</span>
                  </button>
                  <h5
                    className="modal-title text-center"
                    id="exampleModalLabel"
                  >
                    Your order has been placed!
                  </h5>
                </div>
                <div className="modal-body">
                  We've recieved your order for:<hr/><p id ="list"><br/><b>{stuff}</b><br/></p><hr/>
                  Our agent will soon deliver it to you.<br></br> Thank You for your patience. 
                </div>
                <div className="modal-footer">>
                  <div className="left-side"> 
                   <Button
                      className="btn-link"
                      color="danger"
                      type="button"
                      onClick={checkout}
                    >
                      Checkout
                    </Button>
                </div>
                <div className="divider"/>
                <div className="right-side">
                <Button className="btn-link" color="warning" type="button" onClick={cancel}>
                      Clear
                    </Button>
                </div>
                </div>
              </Modal>
        </div>
        <Collapse
          className="justify-content-end"
          navbar
          isOpen={navbarCollapse}
        >
          <Nav navbar>
            <NavItem>
              <NavLink
                data-placement="bottom"
                href="https://twitter.com/"
                target="_blank"
                title="Follow us on Twitter"
              >
                <i className="fa fa-twitter" />
                <p className="d-lg-none">Twitter</p>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                data-placement="bottom"
                href="https://www.facebook.com/"
                target="_blank"
                title="Like us on Facebook"
              >
                <i className="fa fa-facebook-square" />
                <p className="d-lg-none">Facebook</p>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                data-placement="bottom"
                href="https://www.instagram.com/"
                target="_blank"
                title="Follow us on Instagram"
              >
                <i className="fa fa-instagram" />
                <p className="d-lg-none">Instagram</p>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href="/landing-page#main"
                target=""
              >
                <i className="nc-icon nc-layout-11" /> About Us
              </NavLink>
            </NavItem>
            <NavItem>
              <Button
                className="btn-round"
                color="danger"
                id="cart"
                name="cart"
                onClick={toggleModal}
              >
                Cart
              </Button>
            </NavItem>
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
}

export default IndexNavbar;
